import { EquipPriceEnum } from '@/enums'
import type { EquipQuality } from '@/types/equip'

export function getReinforcePrice(reinforcedLevel: number) {
  let price = 25000
  if ([4, 5].includes(reinforcedLevel)) {
    price *= 2
  } else if ([6, 7].includes(reinforcedLevel)) {
    price *= 3
  } else if ([8, 9].includes(reinforcedLevel)) {
    price *= 4
  } else if (reinforcedLevel === 10) {
    price *= 5
  } else if (reinforcedLevel > 10) {
    price *= 6
  }
  return price
}

export function getReinforceRate(reinforcedLevel: number) {
  switch (reinforcedLevel) {
    case 0:
    case 1:
    case 2:
      return 100
    case 3:
      return 90
    case 4:
      return 85
    case 5:
      return 70
    case 6:
      return 60
    case 7:
      return 50
    case 8:
      return 45
    case 9:
      return 40
    case 10:
      return 30
    case 11:
      return 25
    case 12:
      return 20
    case 13:
      return 15
    case 14:
      return 10
    default:
      return 0
  }
}

export function getRiseStarPrice(quality: EquipQuality, starAttrs: number[] | undefined) {
  let price = EquipPriceEnum[quality] * 250
  if (starAttrs) {
    price *= starAttrs.length + 1
  }
  return price
}

export function getInheritPrice(reinforcedLevel: number) {
  if (reinforcedLevel <= 8) return 0
  else if (reinforcedLevel <= 10) return 50000
  else return 100000 * (reinforcedLevel - 10)
}

export function getRecastPrice(quality: EquipQuality) {
  const equipPrice = EquipPriceEnum[quality]
  return equipPrice * 500
}
export function getRecastLockPrice(count: number) {
  if (count < 0) return 0
  return 200 * Math.pow(2, count)
}

export function getEnchantPrice(quality: EquipQuality, enchantAttr: [number, number] | undefined) {
  let price = EquipPriceEnum[quality] * 500
  if (enchantAttr) {
    price *= enchantAttr[0] + 1
  }
  return price
}
export function getEnchantStone(enchantAttr: [number, number] | undefined) {
  return ((enchantAttr?.[0] || 0) + 1) * 5
}